import Swiper from "swiper/bundle";

export default function newsSlider() {
	const newsItemsSwiper = new Swiper(".newsItems", {
		slidesPerView: 1,
		spaceBetween: 30,
		freeMode: true,
		breakpoints: {
			640: {
				slidesPerView: 2,
			},
			1280: {
				slidesPerView: 3,
			},
		},
	});

	newsItemsSwiper && newsItemsSwiper;
	// console.log("newsItemsSwiper", newsItemsSwiper);

	function addDelayInSlides() {
		const slidersCard = document.querySelectorAll(
			".newsItems .swiper-slide > a"
		);
		slidersCard &&
			slidersCard.forEach(
				(elem, index) => (elem.style.transitionDelay = `${index * 0.25}s`)
			);
	}
	addDelayInSlides();
}
